import { postTrackingEvent } from "./client";
import { getTrackingSchemaVersion } from "./config";
import { getCachedVisitorCountry } from "./visitorCountry";
import { v7 as uuidv7 } from "uuid";

export const buildBaseEvent = ({
  schemaVersion,
  visitorCountry,
  category,
  eventType,
  establishmentId,
  publicationId,
  context,
  durationMs,
  tripPreference,
  eventTime,
}) => {
  const visitor = getCachedVisitorCountry();

  return {
    schemaVersion: schemaVersion || getTrackingSchemaVersion(),
    eventId: uuidv7(),
    eventTime: eventTime || new Date().toISOString(),
    category,
    eventType,
    establishmentId: String(establishmentId),
    publicationId: String(publicationId),
    visitorCountry: visitorCountry || visitor.countryCode || undefined,
    tripPreference: tripPreference || undefined,
    durationMs: typeof durationMs === "number" ? durationMs : durationMs ?? undefined,
    context: context || undefined,
  };
};

export const trackEventBestEffort = async (event, { keepalive = false } = {}) => {
  if (!event) return;
  await postTrackingEvent(event, { keepalive });
};
